// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
import { routes as dashboard } from './dashboard'

import { routes as auth } from './auth'
import { routes as report } from './report'
import { routes as gsuite } from './gsuite'
// import { routes as o365 } from './o365'
// https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Operators/Spread_operator
// Thus a new array is created, containing all objects that match the routes.
// ...dashboard must be the last one because of the catchall instruction
export default [...auth,  ...report, ...dashboard, ...gsuite]
// export default [...auth, ...company, ...recipient, ...campaign, ...report, ...dashboard, ...gsuite, ...o365]
/* ...dashboard,*/



// WEBPACK FOOTER //
// ./src/app/routes.js